export default __webpack_public_path__ + "static/media/background_register.9d42f833.jpg";